import styled from 'styled-components';
export default styled.p.withConfig({
  displayName: "Text",
  componentId: "sc-1niwkev-0"
})(["font-size:18px;@media screen and (min-width:800px){font-size:24px;}"]);